module.exports = __webpack_public_path__ + "static_1727318417925/img/giftModule0.6a02fcb5.png";